import { useAuthInfo } from '@propelauth/react';

const ADMIN_ROLE = 'Admin';
const SUPERVISOR_ROLE = 'Supervisor';

export interface AuthPermissions {
  readOnly: boolean;
  isAtLeastSupervisor: boolean;
}

export const UseAuthPermissions = (): AuthPermissions => {
  const { accessHelper, orgHelper } = useAuthInfo();
  if (!accessHelper || !orgHelper) {
    return {
      readOnly: true,
      isAtLeastSupervisor: false,
    };
  }
  let readOnly = true;
  let isSupervisorOrUp = false;
  const orgIds = orgHelper.getOrgIds();
  if (orgIds.length > 0) {
    const org = orgIds[0];
    readOnly = !accessHelper.isAtLeastRole(org, ADMIN_ROLE);
    isSupervisorOrUp = accessHelper.isAtLeastRole(org, SUPERVISOR_ROLE);
  }

  return {
    readOnly,
    isAtLeastSupervisor: isSupervisorOrUp,
  };
};
